var React = require('react');
var Radium = require('radium');

var Nav = require('react-bootstrap/lib/Nav');
var NavItem = require('react-bootstrap/lib/NavItem');
var Col = require('react-bootstrap/lib/Col');
var Row = require('react-bootstrap/lib/Row');
var TabPane = require('react-bootstrap/lib/TabPane');
var TabContent = require('react-bootstrap/lib/TabContent');
var TabContainer = require('react-bootstrap/lib/TabContainer');

var Users = require('../../containers/Admin/Users/Users');
var Couriers = require('../../containers/Admin/Couriers/Couriers');
var Requests = require('../../containers/Admin/Requests/Requests');
var Orders = require('../../containers/Admin/Orders/Orders');
var Settings = require('../../containers/Admin/Settings');
var Financial = require('../../containers/Admin/Financial/Financial');
var Push = require('../../containers/Admin/Push');

var style ={
	container: {
		marginTop: 50,
		position: 'absolute',
		width: '100%',
		height: '100%'
	},

	sidebar: {
		backgroundColor: '#fff',
		padding: 0,
		margin: 0,
		boxShadow: '1px 0px 10px rgba(0, 0, 0, .05)'
	},

	content: {
		padding: 0,
		margin: 0
	}
};

var Dashboard = Radium(React.createClass({

	componentDidMount: function() {
		var content = document.getElementById('admin_sidebar'),
			griddle = document.querySelectorAll('.griddle-body'),
			offset = content.offsetHeight - 200;

			griddle.forEach(function(grid) {
				grid.style.height = offset + 'px';
			});
	},
	
	render: function() {
		return (
			<TabContainer id="admin_sidebar" defaultActiveKey="users" style={style.container}>
				<Row className="clearfix">
					<Col sm={2} style={style.sidebar}>
						<Nav bsStyle="pills" stacked className="side-menu">
							<NavItem eventKey="users">
								<span className="side-menu-item icon-user"/>
								{"Usuários"}
							</NavItem>
							<NavItem eventKey="drivers">
								<span className="side-menu-item icon-driver" />
								{"Entregadores"}
							</NavItem>
							<NavItem eventKey="requests">
								<span className="side-menu-item icon-list"/>
								{"Pedidos"}
							</NavItem>
							<NavItem eventKey="orders">
								<span className="side-menu-item icon-list"/>
								{"Compras"}
							</NavItem>
							<NavItem eventKey="settings">
								<span className="side-menu-item icon-settings"/>
								{"Configurações"}
							</NavItem>
							<NavItem eventKey="financial">
								<span className="side-menu-item icon-wallet"/>
								{"Financeiro"}
							</NavItem>
							<NavItem eventKey="push">
								<span className="side-menu-item icon-push"/>
								{"Enviar notificação"}
							</NavItem>
						</Nav>
					</Col>
					<Col sm={10} style={style.content}>
						<TabContent>
							<TabPane eventKey="users">
								<Users />
							</TabPane>
							<TabPane eventKey="drivers">
								<Couriers />
							</TabPane>
							<TabPane eventKey="requests">
								<Requests />
							</TabPane>
							<TabPane eventKey="orders">
								<Orders />
							</TabPane>
							<TabPane eventKey="settings">
								<Settings />
							</TabPane>
							<TabPane eventKey="financial">
								<Financial />
							</TabPane>
							<TabPane eventKey="push">
								<Push />
							</TabPane>
						</TabContent>
					</Col>
				</Row>
			</TabContainer>
		);
	}

}));

module.exports = Dashboard;


// WEBPACK FOOTER //
// ./src/components/Admin/Dashboard.jsx